import "./links.css";
import React, { useState } from 'react';


export default function Links()
 {  

    return    (
    <div id="wrapper"> 
    
    <div style={{
         padding: "3px 8px",
         color: "#55ba5e",
         fontWeight: "bold",
         backgroundColor:"#ffffff",
          width:"90%",
         padding:"10px",
         margin:"10px",
         float:"left"
       }}> Rationell Reinigen<br></br>
       <a href="https://www.rationell-reinigen.de" style={{color:"#000000",fontSize:"15px"}} target_blank>www.rationell-reinigen.de</a>
       </div>
       <div style={{
         padding: "3px 8px",
         color: "#55ba5e",
         fontWeight: "bold",
         backgroundColor:"#ffffff",
          width:"90%",
         padding:"10px",
         margin:"10px",
         float:"left"
       }}> kma<br></br>
       <a href="https://www.kma-online.de" style={{color:"#000000",fontSize:"15px"}} target_blank>www.kma-online.de</a>
       </div>
       <div style={{
         padding: "3px 8px",
         color: "#55ba5e",
         fontWeight: "bold",
         backgroundColor:"#ffffff",
          width:"90%",
         padding:"10px",
         margin:"10px",
         float:"left"
       }}> GVmanager<br></br>
       <a href="https://www.gastroinfoportal.de/gvmanager-2/" style={{color:"#000000",fontSize:"15px"}} target_blank>www.gastroinfoportal.de/gvmanager-2/</a>
       </div>
       <div style={{
         padding: "3px 8px",
         color: "#55ba5e",
         fontWeight: "bold",
         backgroundColor:"#ffffff",
          width:"90%",
         padding:"10px",
         margin:"10px",
         float:"left"
       }}> DGE - Deutsche Gesellschaft für Ernährung<br></br>
       <a href="https://www.dge.de/gv/dge-qualitaetsstandards/?L=0" style={{color:"#000000",fontSize:"15px"}} target_blank>www.dge.de/gv/dge-qualitaetsstandards/?L=0</a>
       </div>
    
    </div>







    )

 }


